import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItemButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import Dropzone from "components/shared/Dropzone";
import UploadedFile from "components/shared/UploadedFile";
import {
  CHECK_TRANSCRIPT_URL,
  CREATE_CHECKOUT_SESSION,
  REFRESH_CONTENT_MANAGER,
  UPLOAD_FILE_URL,
  UPLOAD_LINK_URL,
} from "config";
import { Timestamp } from "firebase/firestore";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addContentDocument } from "services/firebase";
import { getSpeakers } from "services/uploadNewContent";
import { boxShadow, gradientDarkBackground } from "themes";
import { languageMap, statusType } from "types";
import { canNewFileBeUploaded, processFileName } from "utils";
import { languages } from "./languages";
import { DAFT_SPEAKERS } from "./speakers";
import { useUser } from "hooks/users";

//CSS part

const boxShadowStyle_fileUploader = {
  boxShadow:
    "0px 0.65371px 1.30742px rgba(0, 0, 0, 0.16), 0px 1.30742px 2.61484px rgba(0, 0, 0, 0.12), 0px 0.65371px 5.22968px rgba(0, 0, 0, 0.1)",
};

//uploadSourceType definition
enum UploadSourceType {
  Computer,
  Link,
  // Account,
}
const uploadSourceOptions: UploadSourceType[] = [
  UploadSourceType.Computer,
  // UploadSourceType.Link,
  // UploadSourceType.Account,
];
const UploadSourceText: string[] = ["Computer", "Link", "Account"];

export const NewTranslation = ({
  title,
  type,
  selectedLanguages,
  setSelectedLanguages,
  handleNewTranslation,
  UploadCard,
  handleBack,
}: {
  title: string;
  type: "video" | "podcast";
  selectedLanguages: Set<string>;
  setSelectedLanguages: React.Dispatch<React.SetStateAction<Set<string>>>;
  handleNewTranslation: (
    DAFTSpeaker: string,
    selectedCustomSpeaker: string
  ) => void;
  UploadCard?: () => JSX.Element;
  handleBack?: () => void;
}) => {

  const user = useUser();
  const [DAFTSpeaker, setDAFTSpeaker] = useState("29");
  const [customSpeakers, setCustomSpeakers] = useState<string[]>([]);
  const [selectedCustomSpeaker, setSelectedCustomSpeaker] =
    useState<string>("");

  const handleDaftSpeakerDropdown = (e: SelectChangeEvent) => {
    setDAFTSpeaker(e.target.value as string);
  };

  const handleCustomSpeakerDropdown = (e: SelectChangeEvent) => {
    setSelectedCustomSpeaker(e.target.value as string);
  };

  useEffect(() => {
    const fetchSpeakers = async () => {
      const speakers = await getSpeakers(user!.uid);
      setCustomSpeakers(speakers);
    };
    fetchSpeakers();
  }, []);

  const handleSelectLanguage =
    (language: string) => (e: React.SyntheticEvent) => {
      setSelectedLanguages((prevSelectedLanguages: Set<string>) => {
        const newSelectedLanguages = new Set<string>(prevSelectedLanguages);
        if(newSelectedLanguages.size > 0){
          newSelectedLanguages.clear();
        }
        if (newSelectedLanguages.has(language)) {
          newSelectedLanguages.delete(language);
        } else {
          newSelectedLanguages.add(language);
        }
        return newSelectedLanguages;
      });
    };

  const handleBackButton = () => {
    handleBack && handleBack();
  };

  const handleClickStartTranslation = () => {
    handleNewTranslation(DAFTSpeaker, selectedCustomSpeaker);
  };

  return (
    <Stack sx={{ maxWidth: 450 }}>
      <Stack>
        <Typography variant="h4">{title}</Typography>
        <Typography variant="body2">{type}</Typography>
      </Stack>
      {UploadCard && (
        <Box sx={{ p: 2 }}>
          <UploadCard />
        </Box>
      )}
      <TextField
        placeholder="Search"
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {/* language options  */}
      <List>
        {languages.map((language) => (
          <Stack
            key={language.code}
            component={ListItemButton}
            direction={"row"}
            disabled={!language.available}
            onClick={handleSelectLanguage(language.code)}
            sx={{ alignItems: "center" }}
          >
            <Box>
              <Checkbox checked={selectedLanguages.has(language.code)} />
            </Box>
            <Stack>
              {/* ${!language.available && "(Not available)"} */}
              <Typography variant="body2">{`${
                languageMap[language.code]
              }`}</Typography>
              <Typography variant="caption">{language.country}</Typography>
            </Stack>
          </Stack>
        ))}
      </List>

      {/* speaker dropdowns */}
      {/*<FormControl fullWidth>
        <InputLabel id="Daft speaker">Speaker</InputLabel>
        <Select
          labelId="Daft speaker"
          id="Daft speaker"
          value={DAFTSpeaker}
          label="speaker"
          onChange={handleDaftSpeakerDropdown}
        >
          {DAFT_SPEAKERS.map((speaker, index) => (
            <MenuItem key={index} value={speaker.id}>
              {speaker.speaker}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
      {/* customSpeakers.length > 0  &&  */}
      {/* {(
        <FormControl fullWidth>
          <InputLabel id="speaker">Speaker</InputLabel>
          <Select
            labelId="speaker"
            id="speaker"
            value={selectedCustomSpeaker}
            label="Speaker"
            onChange={handleCustomSpeakerDropdown}
          >
            {customSpeakers.map((speaker) => (
              <MenuItem value={speaker}>{speaker}</MenuItem>
            ))}
            <MenuItem value={"109"}>{"109 test"}</MenuItem>
          </Select>
        </FormControl>
      )} */}
      <Stack direction="row">
        {handleBack && (
          <Button onClick={handleBackButton} sx={{ flexGrow: 1 }}>
            Back
          </Button>
        )}
        <Button onClick={handleClickStartTranslation} sx={{ flexGrow: 1 }}>
          <CachedIcon />
          Start Translation
        </Button>
      </Stack>
    </Stack>
  );
};

interface Component1Props {
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

const Component1: React.FC<Component1Props> = ({ files, setFiles }) => {
  return (
    <>
      {files.length ? (
        <UploadedFile file={files[0]} />
      ) : (
        <Dropzone
          message="Drag 'n' drop some files here, or click to select file"
          setFiles={setFiles}
        />
      )}
    </>
  );
};

interface Component2Props {
  link: string;
  linkChange: (link: string) => void;
}

const Component2: React.FC<Component2Props> = ({ link, linkChange }) => {
  const handleLinkChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLink = event.target.value;
    linkChange(newLink);
  };

  return (
    <>
      <TextField
        required
        id="outlined-required-static"
        label="Link From The Web"
        multiline
        value={link}
        onChange={handleLinkChange}
        rows={4}
        sx={{
          wordWrap: "break-word",
          overflowWrap: "break-word",
        }}
      />
    </>
  );
};

// total container
interface UploadData {
  files: File[];
  link: string;
  title: string;
  description: string;
  previewImage?: any; // TODO preview image
  humanVerification?: boolean; // TODO human verification
}

const Upload = ({
  uploadData,
  handleChooseLanguage,
}: {
  uploadData: UploadData | undefined;
  handleChooseLanguage: (
    uploadSource: UploadSourceType,
    uploadData: UploadData
  ) => void;
}) => {
  const [uploadSource, setUploadSource] = useState<UploadSourceType>(
    UploadSourceType.Computer
  );
  const [humanVerification, setHumanVerification] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>(uploadData?.files || []);
  const [link, setLink] = useState(uploadData?.link || "");
  const [title, setTitle] = useState(uploadData?.title || "");
  const [description, setDescription] = useState(uploadData?.description || "");

  const handleLinkChange = (newLink: string) => {
    setLink(newLink);
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();

    const uploadData: UploadData = {
      files,
      link,
      title,
      description,
      humanVerification: false,
    };

    handleChooseLanguage(uploadSource, uploadData);
  };

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);
    if (query.get("success")) {
      enqueueSnackbar("Your payment was successful!", { variant: "success" });
      setHumanVerification(true);
    }
    if (query.get("canceled")) {
      enqueueSnackbar("Your payment was canceled", { variant: "error" });
      setHumanVerification(false);
    }
  }, []);

  const handleHumanVerificationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setHumanVerification(event.target.checked);
    if (event.target.checked) {
      window.open(CREATE_CHECKOUT_SESSION, "_blank");
    }
  };

  return (
    <Stack sx={{ justifyContent: "space-between", flexGrow: 1 }}>
      <Stack
        spacing={2}
        sx={{
          justifyContent: "space-between",
          p: 4,
        }}
      >
        <Stack direction="row">
          {uploadSourceOptions.map((source: UploadSourceType) => (
            <Button
              key={source}
              onClick={() => setUploadSource(source)}
              size="small"
              sx={{
                ...boxShadowStyle_fileUploader,
                flexGrow: 1,
                backgroundColor:
                  source === uploadSource ? "#3A5465" : "#FFFFFF",
                color: source === uploadSource ? "#F3F3F3" : "#434343",
                "&:hover": {
                  backgroundColor:
                    source === uploadSource ? "#3A5465" : "#FFFFFF",
                  color: source === uploadSource ? "#F3F3F3" : "#434343",
                },
              }}
            >
              {UploadSourceText[source]}
            </Button>
          ))}
        </Stack>
        {uploadSource === UploadSourceType.Computer && (
          <Component1 files={files} setFiles={setFiles} />
        )}
        {uploadSource === UploadSourceType.Link && (
          <Component2 link={link} linkChange={handleLinkChange} />
        )}
        {/* {uploadSource === UploadSourceType.Account && <Component3 />} */}
        {/* <Stack direction={"row"} sx={{ bgcolor: "white", borderRadius: 1 }}>
          <Stack
            sx={{
              bgcolor: "info.main",
              height: 96,
              justifyContent: "center",
              p: 1.5,
              borderTopLeftRadius: 4,
              borderBottomLeftRadius: 4,
            }}
          >
            <ImageIcon fontSize={"medium"} sx={{ color: "white" }} />
          </Stack>

          <Stack sx={{ justifyContent: "center", p: 2 }}>
            <Typography variant="body2">Preview Image</Typography>
            <Typography variant="caption">
              (Optional) Add a cover image for publishing and to make your
              content more recognizable.
            </Typography>
          </Stack>
        </Stack> */}

        <TextField
          label="Content Title"
          value={title}
          variant="outlined"
          required
          onChange={(e) => setTitle(e.target.value)}
          sx={{ bgcolor: "white" }}
        />

        <TextField
          label="Content Description"
          size="small"
          multiline
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ bgcolor: "white" }}
        />

        {/* <Stack direction={"row"} sx={{ bgcolor: "#FFF2E2", borderRadius: 1 }}>
          <Stack
            sx={{
              bgcolor: "secondary.dark",
              height: 96,
              justifyContent: "center",
              p: 1,
              borderTopLeftRadius: 4,
              borderBottomLeftRadius: 4,
            }}
          >
            <PersonPinCircleIcon fontSize="large" sx={{ color: "white" }} />
          </Stack>
          <Stack sx={{ justifyContent: "center", p: 2 }}>
            <Typography variant="body2">Utilize Human Verifier?</Typography>
            <Typography variant="caption">
              Adding a verifier will charge your account $10.00 upon
              translation.
            </Typography>
          </Stack>
          <Box sx={{ alignSelf: "center", mr: 1 }}>
            <Checkbox
              checked={humanVerification}
              onChange={handleHumanVerificationChange}
            />
          </Box>
        </Stack> */}
      </Stack>
      <Button
        onClick={handleSubmit}
        sx={{
          backgroundColor: "secondary.light",
          width: "100%",
          boxShadow: boxShadow,
        }}
      >
        <Stack
          direction={"row"}
          sx={{
            justifyContent: "right",
            width: "100%",
            maxHeight: 40,
            py: 3,
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
            Choose Languages
          </Typography>
          <ArrowForwardIcon sx={{ ml: 2, mr: 2 }} />
        </Stack>
      </Button>
    </Stack>
  );
};

const NewContent = ({
  setDrawerOpen,
  files,
}: {
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  files?: File[];
}) => {
  const navigate = useNavigate();
  const user = useUser();
  const [page, setPage] = useState(1);

  const [uploadData, setUploadData] = useState<UploadData>({
    files: files || [],
    link: "",
    title: "",
    description: "",
  });

  const [uploadSource, setUploadSource] = useState<UploadSourceType>(
    UploadSourceType.Computer
  );

  const [selectedLanguages, setSelectedLanguages] = useState<Set<string>>(
    new Set()
  );

  const handleChooseLanguage = (
    uploadSource: UploadSourceType,
    uploadData: UploadData
  ) => {
    // if (uploadData.files.length === 0) {
    //   alert("Please select a file");
    //   return;
    // }
    setUploadData(uploadData);
    setUploadSource(uploadSource);
    if (uploadSource === UploadSourceType.Computer) {
      if (uploadData.files.length > 0 && uploadData.title) {
        setPage(2);
      }
    } else if (uploadSource === UploadSourceType.Link) {
      if (uploadData.link && uploadData.title) {
        setPage(2);
      }
    }
  };

  const handleNewContentTranslation = async (
    DAFTSpeaker: string,
    customSpeaker: string
  ) => {
    // TODO: Use the uploaded files and other user input to create a new translation
    if (uploadData) {
      const { files, title, description, link, humanVerification } = uploadData;
      const selectedLanguagesArray = Array.from(selectedLanguages);
      const userId = user!.uid;

      const translatedLanguages: {
        [key: string]: { status: string; progress: number };
      } = {};
      selectedLanguagesArray.forEach((language) => {
        translatedLanguages[language] = {
          status: statusType.Uploaded,
          progress: 0,
        };
      });

      try {
        if (!(await canNewFileBeUploaded(userId))) {
          enqueueSnackbar(
            "Please wait for your previous file to finish processing!",
            { variant: "warning", autoHideDuration: 3000 }
          );
          return;
        }

        // add initial content document on firebase

        const originalLanguage = selectedLanguagesArray[0] === "en" ? "es" : "en";
        const content_data_id = await addContentDocument(userId, {
          date: Timestamp.fromDate(new Date()),
          source_filename: files[0].name.replace(/\s/g, "_"),
          title: title,
          description: description,
          originalLanguage: originalLanguage, //TODO
          preview_image: "linktopreviewimage", //TODO
          status: statusType.Uploaded,
          uid: user!.uid,
          type: "video", //TODO
        });

        if (uploadSource === UploadSourceType.Computer) {
          const formData = new FormData();
          ///translated target language
          formData.append("lang", selectedLanguagesArray[0]); // TODO: deprecate when backend can handle multiple languages
          //multiple languages
          // selectedLanguagesArray.forEach((language) => {
          //   formData.append("languages[]", language);
          // });

          ///speech to text language
          formData.append("asr_lang", "en-US");

          ///untranslated original language

          formData.append("input_lang", originalLanguage);
          const originalname =
            (user!.uid || "") + "/" + content_data_id + "/" + files[0].name;
          formData.append("fileName", originalname);
          formData.append(
            "files",
            processFileName(files[0], content_data_id, originalname)
          );
          formData.append("uid", user!.uid || "");
          formData.append("content_data_id", content_data_id);


          formData.append("DAFTSpeaker", DAFTSpeaker);
          formData.append("customSpeaker", customSpeaker);

          

          const url = humanVerification
            ? CHECK_TRANSCRIPT_URL
            : UPLOAD_FILE_URL;

          const jsonObject: any = {};
          for (const [key, value] of formData.entries()) {
            jsonObject[key] = value;
          }

          setDrawerOpen(false);
          navigate("/content");
          enqueueSnackbar("Your content is being processed!", {
            variant: "success",
            autoHideDuration: 3000,
          });

          await axios.post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        } else if (uploadSource === UploadSourceType.Link) {
          const req = {
            lang: selectedLanguagesArray[0],
            asr_lang: "en-US",
            input_lang: "en",
            originalLanguage: "en",
            uid: user!.uid || "",
            content_data_id: content_data_id,
            link: link,
          };

          const response = await axios.post(UPLOAD_LINK_URL, req, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          console.log("Upload response:");
          console.log(response);
          const jobID = response.data;
          const status = response.statusText;
          console.log("jobID: ", jobID);
          console.log(status);
        }
      } catch (error) {
        console.log(error);
      }
    }
    window.parent.postMessage({ type: REFRESH_CONTENT_MANAGER }, "*");
  };

  const handleBack = () => {
    setPage(1);
  };

  const renderUploadCard = () => {
    switch (uploadSource) {
      case UploadSourceType.Computer:
        return <UploadedFile file={uploadData!.files[0]} />;
      case UploadSourceType.Link:
        return (
          <>
            <TextField
              required
              id="outlined-read-only-required-static"
              label="Link From The Web"
              multiline
              value={uploadData!.link}
              rows={4}
              sx={{
                width: "100%",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
              InputProps={{
                readOnly: true, // Optional: Set the TextField as readOnly
              }}
            />
          </>
        );
      default:
        return <></>; // Make sure to handle the default case
    }
  };

  return (
    <Stack sx={{ height: "100%", width: 450, bgcolor: "background.default" }}>
      <Stack
        direction="row"
        sx={{ background: gradientDarkBackground, pt: 4, pb: 3.5 }}
      >
        <AddIcon
          sx={{ height: 35, width: 35, color: "secondary.main", mx: 3 }}
        />
        <Stack>
          <Typography variant="h4" sx={{ color: "background.default" }}>
            New Content
          </Typography>
          <Typography variant="body2" sx={{ color: "grey.200" }}>
            {page === 1
              ? "Upload your content and begin a translation"
              : "Select the languages you'd like to translate to"}
          </Typography>
        </Stack>
      </Stack>
      {page === 1 ? (
        <Upload
          uploadData={uploadData}
          handleChooseLanguage={handleChooseLanguage}
        />
      ) : (
        <NewTranslation
          title={uploadData?.title || "[temp title]"}
          type="video"
          selectedLanguages={selectedLanguages}
          UploadCard={renderUploadCard}
          setSelectedLanguages={setSelectedLanguages}
          handleNewTranslation={handleNewContentTranslation}
          handleBack={handleBack}
        />
      )}
    </Stack>
  );
};

export default NewContent;
